import { Popover } from 'antd';

export const CustomPopup = ({ children, isOpen, message }) => {
  const content = (
    <div className="mr-2">
      <p className="max-w-[150px] text-[16px] font-semibold text-primary">{message}</p>
    </div>
  );
  return (
    <div>
      {!isOpen ? (
        <Popover content={content} trigger="hover">
          {children}
        </Popover>
      ) : (
        <Popover content={content} open>
          {children}
        </Popover>
      )}
    </div>
  );
};
